import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import Img from "gatsby-image"
import { useIntl, FormattedMessage } from "react-intl"
import { langId } from "../languages"
import { useLinkLanguage, useIsLangEN, useFeatureStory } from "../hooks"
import classnames from "classnames"
import { Menu } from "../components"
import { linkConfig } from "../config"

const Navbar = ({ defaultSubMenuVisible = false, baseSlug }) => {
  const Images = useStaticQuery(graphql`
    query {
      linkreitLogo: file(relativePath: { eq: "images/linkreit-logo.png" }) {
        ...fragmentsFluidImage
      }

      channel823: file(
        relativePath: { eq: "images/linkreit-channel-823-logo.png" }
      ) {
        ...fragmentsFluidImage
      }
    }
  `)
  const intl = useIntl()
  const linkLang = useLinkLanguage()
  const isLangEN = useIsLangEN()
  const featureStory = useFeatureStory()
  const isInFeatureStory =
    featureStory.subMenu.filter(story => story.baseSlug === baseSlug).length > 0

  return (
    <div className="navbar">
      <div className="navbar__link-riet">
        <a
          href={`https://www.linkreit.com/${linkLang}/home/`}
          rel="noopener"
          target="_blank"
          title={intl.formatMessage({ id: langId.LINK_REIT })}
        >
          <Img
            fluid={Images.linkreitLogo.childImageSharp.fluid}
            alt={intl.formatMessage({ id: langId.LINK_REIT })}
            title={intl.formatMessage({ id: langId.LINK_REIT })}
          ></Img>
        </a>
      </div>
      <div className="navbar__channel-823">
        <Link
          to={`/${intl.locale}/`}
          title={intl.formatMessage({ id: langId.CHANNEL_823 })}
        >
          <Img
            fluid={Images.channel823.childImageSharp.fluid}
            alt={intl.formatMessage({ id: langId.CHANNEL_823 })}
            title={intl.formatMessage({ id: langId.CHANNEL_823 })}
          ></Img>
        </Link>
      </div>
      <div
        className={classnames({
          navbar__navigator: true,
          "navbar__navigator--en": isLangEN,
        })}
      >
        <ul>
          {linkConfig.map(link => (
            <Link
              key={link.baseSlug}
              to={`/${intl.locale}/${link.baseSlug ? link.baseSlug + "/" : ""}`}
              className={classnames({
                navbar__navigator__link: true,
                "navbar__navigator__link--en": isLangEN,
                "current-page":
                  (link.baseSlug === featureStory.baseSlug &&
                    isInFeatureStory) ||
                  link.baseSlug === baseSlug,
              })}
              activeClassName="current-page"
              title={intl.formatMessage({ id: link.title })}
            >
              <li>
                <FormattedMessage
                  id={link.title}
                  title={intl.formatMessage({ id: link.title })}
                ></FormattedMessage>
              </li>
            </Link>
          ))}
        </ul>
      </div>
      <Menu
        defaultSubMenuVisible={defaultSubMenuVisible}
        baseSlug={baseSlug}
      ></Menu>
    </div>
  )
}

export default Navbar
